<template>
  <div class="register-view">
    <div style="font-size: 24px;color:#d6e6f8;font-weight: 500;padding: 30px 10px;">{{ $t('other.totrade') }}</div>
    <div style="width: 80%;margin: 0 auto;"><van-button :color='"linear-gradient(313deg,#13e8ff,#00b5c9)"' style="border-radius: 6px;width: 100%;">
        <span style="color: #000;font-size: 16px;">{{ $t('other.toregister') }}</span>
    </van-button></div>
  </div>
</template>

<script>
export default {
  name: 'ToRegisterView'
}
</script>
<style scoped>
.register-view{
    margin-top: 10px;
    width: 100%;
    height: 172px;
    background-image: url(../../../assets/22052208.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
}
</style>
